import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { VoxnelaProvider } from './contexts/VoxnelaContext'
import { initializePlatformServices } from './lib/platform'
import './i18n'
import './styles/global.css'
import './styles/fortale-island.css'
import './styles/video.css'
import './styles/video-final.css'
import './styles/studio.css'
import './styles/visual-style-modal.css'
import './styles/paywall-spone.css'
import './styles/ai-data-consent.css'

void initializePlatformServices()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <AuthProvider>
        <VoxnelaProvider>
          <App />
        </VoxnelaProvider>
      </AuthProvider>
    </HashRouter>
  </StrictMode>,
)
